<template>
	<div>
		<div class="title">
			<div class="header">
				<div class="header_title-container title">
					<h1>{{ $t("sitesettings") }}</h1>
				</div>

				<div class="header_actions">
					<div class="header_actions-container">
						<el-button type="success" @click="handleSave">
							{{ $t("save") }}
						</el-button>
						<el-tooltip placement="bottom">
							<div slot="content">{{ $t("cancel") }}</div>
							<el-button @click="handleReset" circle size="small">
								<md-icon>clear</md-icon>
							</el-button>
						</el-tooltip>
					</div>
				</div>
			</div>
		</div>
		<div style="width: 100%" :style="{ height: height + 'px' }">
			<div style="width: 55%; margin-left: auto; margin-right: auto; overflow-y: auto; padding: 15px">
				<el-form class="demo-ruleForm">
					<el-form-item v-for="s in this.mysettings" prop="old" :key="s.id" style="height: 60px">
						<strong slot="label">{{ $t(s.key) }}</strong>
						<el-input v-model="s.value" />
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import { mapActions, mapGetters } from "vuex"

export default {
	name: "Settings",

	computed: {
		...mapGetters({
			settings: "modules/admin_settings"
		})
	},
	data() {
		return {
			heightscreen: window.innerHeight - 120,
			height: window.innerHeight - 260,
			mysettings: []
		}
	},
	created() {
		this.doSettings()
		this.mysettings = this.filterAdminSettings()
	},
	watch: {
		settings() {
			this.mysettings = this.filterAdminSettings()
		}
	},
	methods: {
		...mapActions({
			doSettings: "modules/doSettings"
		}),
		filterAdminSettings() {
			var settings = []
			for (const [k, s] of Object.entries(this.settings)) {
				if (s.admin_access) settings.push({ ...s })
			}
			return settings
		},
		handleReset() {
			this.mysettings = this.filterAdminSettings()
		},
		handleSave() {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/setting/update",
					{ settings: this.mysettings },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					this.doSettings()
					this.$notification("success", this.$t("save-successful"), "", 4500)
				})
				.catch(err => {
					this.$notification("error", this.$t("save-error"), "", 0)
					console.error(err)
				})
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-form";

h3 {
	font-family: "Montserrat", sans-serif;
}
</style>
